import { Layout, theme } from 'antd';
import Footers from '../../components/Footer';
import Headers from '../../components/Header';
import Siders from '../../components/Sider';
import { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UpdateMC from '../../components/MenuAz/Updatemenu';
const { Content } = Layout;

const UpdateM = () => {

    const {
        token: { colorBgContainer },
    } = theme.useToken();

    return (
        <Layout
            style={{
                minHeight: '100vh',
            }}
        >
            <Siders />
            <Layout>
                <Headers />
                <Content
                    className="site-layout"
                    style={{
                        padding: '0 10px',
                    }}
                >
                    <div
                        style={{
                            padding: 4,
                            minHeight: 380,
                            background: colorBgContainer,
                        }}
                    >
                        <UpdateMC />
                    </div>
                </Content>
                <Footers />
            </Layout>
        </Layout>
    );
};

export default UpdateM;
